import React from 'react';
import logo from '../../assets/images/club-logo.svg';

interface IClubLogoProps {
  src?: string;
  bordered?: boolean;
  className?: string;
  borderRadius?: 'squared' | 'rounded' | 'circle';
}

const ClubLogo = ({ src, bordered, className, borderRadius }: IClubLogoProps): JSX.Element => {
  const classNames =
    `club-logo ${className || ''} ` +
    (bordered ? 'bordered ' : '') +
    (borderRadius ? borderRadius : '');

  return (
    <div className={classNames}>
      <img src={src || logo} className="logo" alt="logo" />
    </div>
  );
};

export { ClubLogo };
